import React, { useEffect, useState } from 'react';

import StarRating from 'react-star-ratings';

import '../../css/global.css';
import './rating.css';

interface Props {
  textCaption: string;
  value: (value: number) => void;
}

const Rating: React.FC<any> = ({ textCaption, value }: Props) => {
  const [rating, setRating] = useState(1);

  useEffect(() => {
    value(rating);
  }, [rating]);

  return (
    <div className="d-flex w-100 justify-content-start align-items-center container-rating">
      <p className=" description-rating">{textCaption}</p>
      <div className="d-flex ms-2 ">
        <div className="d-flex align-items-center justify-content-start ms-2">
          <StarRating
            name="react-star-rating"
            numberOfStars={5}
            rating={rating}
            changeRating={(newRating: number): void => setRating(newRating)}
            starEmptyColor="#ced4da"
            starHoverColor="#ffc107"
            starRatedColor="#ffc107"
            starDimension="2.31rem"
          />
        </div>
      </div>
    </div>
  );
};

export default Rating;
